import React from 'react';
import styled from '@styled';
import { font_montserrat, font_nunito, tabletPortrait } from '../global.styles';

interface StyledSpanProps {
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  margin?: string;
  padding?: string;
  textDecoration?: string;
  cursor?: string;
  mobileFontSize?: string;
  transform?: string;
  display?: string;
  fontFamily?: string;
  lineHeight?: string;
  boldColor?: string;
}

export const StyledSpan = styled('span').withConfig({
  shouldForwardProp: (prop) =>
    !['fontSize', 'fontWeight', 'textDecoration', 'mobileFontSize', 'fontFamily', 'lineHeight', 'boldColor'].includes(prop),
})<StyledSpanProps>`
  font-size: ${(props) => props.fontSize || '16px'};
  color: ${(props) => props.color || '#000'};
  margin: ${(props) => props['data-margin'] || '0'};
  display: ${(props) => props.display || 'inline'};
  font-family: ${font_montserrat};
  padding: ${(props) => props['data-padding'] || '0'};
  font-weight: ${(props) => props.fontWeight || '500'};
  text-transform: ${(props) => props.transform || 'none'};
  text-decoration: ${(props) => props.textDecoration || 'none'};
  cursor: ${(props) => props.cursor || 'normal'};
  font-family: ${(props) => props.fontFamily || font_nunito};
  line-height: ${(props) => props.lineHeight || '1.75'};
  background: ${(props) => props.background || 'none'};
  border: ${(props) => props.border || 'none'};
  border-radius: ${(props) => props.borderRadius || '0'};

  strong {
    color: ${(props) => props.boldColor || props.color || '#606E7B'};
  }
  ${tabletPortrait} {
    font-size: ${(props) => props.mobileFontSize || props.fontSize || '16px'};
  }
`;
